import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

export const useSendShopifyStore = () => {
  const { t } = useTranslation();

  return useMutation<ApiResponse<null>, ApiError<null>, string>(
    (store: string) => dataFetch.post(
      `${CORE_API_SUFFIX}organization-settings/shopify/paid-at`,
      {
        shopifyShop: store,
      },
    ),
    {
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
